import initialState from './initialState';
import * as types from '../constants/actionTypes';
import Immutable from 'seamless-immutable';
import { CATEGORY_ID } from '../constants/category';

export default function recentlyValidatedReducer(state = initialState.recentlyValidatedReducer, action) {
  switch (action.type) {
    case types.UPDATE_STATE_VALIDATED_SUCCESS: {
      // console.log(action)
      return state.merge({ ...action.data });
    }
    case types.GET_LIST_ENTITIES_SUCCESS: {
      const { categoryId, data, params } = action;
      const { filter, defaultFilter } = Immutable.asMutable(state);
      let updateObject = {};
      if (categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
        updateObject = {
          filter: {
            ...filter,
            location: {},
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          defaultFilter: {
            ...defaultFilter,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
            location: {},
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.UPDATE_MEMBER_TYPE_STATE_VALIDATED: {
      const { flag, index } = action;
      state = state.setIn(['filter', 'showMeMemberType', 'contentTabs', 0, 'data', index, 'active'], flag);
      return state;
    }
    case types.UPDATE_RECENTLY_VALIDATION_STATUS: {
      const { status } = action;
      state = state.setIn(['isLoading'], status);
      return state;
    }
    case types.GET_RECENTLY_VALIDATION_DATA_SUCCESS: {
      const { data, params } = action;
      const mergeData = {
        data: params.page === 1 || !params?.page ? data : [...state.data, ...data],
        isHasMoreDate: data?.length === 24,
        page: params.page || 1,
      };
      return state.merge({ ...mergeData });
    }
    default:
      return state;
  }
}
